import { styled } from '@mui/system';
import { DataGrid } from '@mui/x-data-grid';
import { DialogContent, Link } from '@mui/material';

export const ChangeRequestGrid = styled(DataGrid)({
  minHeight: 200,
});

export const DropzoneRoot = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isDragActive',
})<{ isDragActive: boolean }>(({ theme, isDragActive }) => ({
  width: '100%',
  height: '100%',
  backgroundColor: isDragActive
    ? theme.palette.primary[800]
    : theme.palette.primary[900],
  borderStyle: 'dashed',
  borderColor: theme.palette.primary.main,
  cursor: 'pointer',
  overflow: 'auto',
}));

export const NoFiles = styled('div')({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const CodeDialogContent = styled(DialogContent)({
  padding: 0,
});

export const DocumentLink = styled(Link)({
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
});
